import { combineReducers } from 'redux';
import {
    EssentialServicesFetchSuccessActionType,
    EssentialServicesFetchRequestActionType,
    EssentialServicesFetchFailureActionType,
} from './essentialServicesAction';
import { ActionType } from 'store/ActionType';
import { EssentialService } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const items = (
    state: Nullable<EssentialService[]> = null,
    action: ActionType,
) => {
    switch (action.type) {
        case EssentialServicesFetchSuccessActionType:
            {
                return action.payload;
            }
        default: {
            return state;
        }
    }
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case EssentialServicesFetchRequestActionType: {
            return true;
        }
        case EssentialServicesFetchFailureActionType:
        case EssentialServicesFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    items,
    isLoading,
});
